
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/store-group",
      function () {
        return require("private-next-pages/templates/store-group.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/store-group"])
      });
    }
  